const { ClipboardItem } = window;

(function ($) {
    $(function () {
        $('.toast.auto-show').toast('show')

        $('[data-toggle="tooltip"]').tooltip()
    });
  })(jQuery);
